/**
 * @generated SignedSource<<6c27c5c061218de51c69c927503be28a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceGroupsListRow_serviceGroup$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
  readonly " $fragmentType": "ServiceGroupsListRow_serviceGroup";
};
export type ServiceGroupsListRow_serviceGroup$key = {
  readonly " $data"?: ServiceGroupsListRow_serviceGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceGroupsListRow_serviceGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceGroupsListRow_serviceGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    }
  ],
  "type": "ServiceGroup",
  "abstractKey": null
};

(node as any).hash = "b11d41abcd182aa51da1ced0a82dbc4b";

export default node;
